// extracted by mini-css-extract-plugin
module.exports = {"modal":"CommentModal_modal__2d68V","backdrop":"CommentModal_backdrop__3hdME"};